import { ReactEditor } from 'slate-react';
import { BaseEditor } from 'slate';

export type CommentType = 'COMMENT' | 'REMIX';
type ParagraphElement = { type: 'paragraph'; children: CustomText[] };
export type LinkElement = { type: 'link'; url: string; children: CustomText[] };
type CustomText = {
  text: string;
  bold?: true;
  code?: true;
  italic?: true;
  underline?: true;
  strikethrough?: true;
};

export type TextModifier =
  | 'bold'
  | 'code'
  | 'italic'
  | 'underline'
  | 'strikethrough';

// TODO: move this type stuff somewhere sane...
declare module 'slate' {
  interface CustomTypes {
    Editor: BaseEditor & ReactEditor;
    Element: ParagraphElement | LinkElement;
    Text: CustomText;
    Descendant: ParagraphElement | LinkElement | CustomText;
  }
}

export type CommentItem = {
  type: CommentType;
  item: Comment | RemixComment;
};

export type Comment = {
  commentId: number;
  created: Date;
  updated: Date;
  replyToCommentId?: number;
  communityPostId: number;
  communityRevisionId: number;
  owner: CommentAuthor;
  // TODO: this is temporary while we support file based lookup
  data: CommunityComment;
  replies: Comment[];
  isDeleted: boolean;
  isEdited: boolean;
  isHidden: boolean;
};

type CommunityComment = {
  comment: CommentAncestor[];
};

export type CommentAuthor = {
  ownerId: number;
  name?: string;
  username: string;
  avatar: string;
};

export function authorName(author: CommentAuthor) {
  return author.name || author.username;
}

type CommentParagraph = {
  type: 'paragraph';
  children: CommentElement[];
};
type CommentLink = {
  type: 'link';
  url: String;
  children: CommentElement[];
};

export type CommentText = {
  type: 'text';
  text: String;
  bold?: true;
  code?: true;
  italic?: true;
  underline?: true;
  strikethrough?: true;
};
export type CommentAncestor = CommentParagraph | CommentLink;
type CommentElement = CommentText | CommentAncestor;

export class RemixCommentResponse {
  constructor(
    public community_post_id: number,
    public community_revision_id: number,
    public title: string,
    public thumbnail_url: string,
    public thumbnail_animation: string,
    public artboard: string,
    public file_url: string,
    public slug: string,
    public username: string,
    public avatar: string,
    public owner_id: number
  ) {}

  static fromData(data: any) {
    return new RemixCommentResponse(
      data.community_post_id,
      data.community_revision_id,
      data.title,
      data.thumbnail_url,
      data.thumbnail_animation,
      data.artboard,
      data.file_url,
      data.slug,
      data.username,
      data.avatar,
      data.owner_id
    );
  }

  toRemixComment(): RemixComment {
    return {
      communityPostId: this.community_post_id,
      communityRevisionId: this.community_revision_id,
      title: this.title,
      thumbnailUrl: this.thumbnail_url,
      thumbnailAnimation: this.thumbnail_animation,
      artboard: this.artboard,
      fileUrl: this.file_url,
      slug: this.slug,
      username: this.username,
      avatar: this.avatar,
      ownerId: this.owner_id,
    };
  }
}

export type RemixComment = {
  communityPostId: number;
  communityRevisionId: number;
  title: string;
  thumbnailUrl: string;
  thumbnailAnimation: string;
  artboard: string;
  fileUrl: string;
  slug: string;
  username: string;
  avatar: string;
  ownerId: number;
};
